var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-img",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy",
              value: _vm.placeholderUrl,
              expression: "placeholderUrl",
            },
          ],
          on: { click: _vm.handlePreview },
        },
        "b-img",
        _vm.attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }